const HOST = process.env.VUE_APP_XIAOHOUCODE_HOST || '';
const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
  cmUrl: `${BASE_URL}/core/cm/challenge/`,
  frTeaUrl: `${HOST}/login/#/teacher`,
  frStuUrl: `${HOST}/login/#/student`,
};
